import React, { Component } from 'react';
import AssetConstants from '@progressivebeef/shared/src/constants/AssetConstants';
import './style.scss';

class SlideInModal extends Component {
  static defaultProps = {
    onRequestClose: () => {},
    show: false,
    title: '',
    showHeader: true,
    showCloseButton: true,
    maxWidth: '400px',
  };

  handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      this.props.onRequestClose();
    }
  };

  render() {
    const {
      show,
      onRequestClose,
      title,
      showHeader,
      showCloseButton,
      maxWidth,
      children,
    } = this.props;

    return (
      <div
        className={`slide-in-modal${show ? ' slide-in-modal-show' : ''}`}
      >
        <div className="slide-in-modal-mask" onClick={this.handleBackdropClick}></div>
        <div
          className="slide-in-modal-wrap"
          style={{ maxWidth }}
        >
          <div className="slide-in-modal-content">
            {showHeader && (
              <div className="slide-in-modal-header">
                {title && (
                  <h3 className="slide-in-modal-title">{title}</h3>
                )}
                {showCloseButton && (
                  <button
                    className="slide-in-modal-close"
                    onClick={onRequestClose}
                    aria-label="Close"
                  >
                    <img src={AssetConstants.recordCross} alt="Close" />
                  </button>
                )}
              </div>
            )}
            <div className="slide-in-modal-body">{children}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default SlideInModal;

